import AutomationTab from './AutomationTab';

export default AutomationTab;
